var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54855 12.9448C7.94571 12.9448 9.25029 12.4903 10.3108 11.7328L14.3003 15.7223C14.4854 15.9074 14.7295 16 14.982 16C15.5291 16 15.9247 15.5792 15.9247 15.0405C15.9247 14.788 15.8405 14.5523 15.6553 14.3672L11.6911 10.3945C12.5244 9.30037 13.0209 7.94529 13.0209 6.47238C13.0209 2.91215 10.1088 0 6.54855 0C2.97991 0 0.0761719 2.91215 0.0761719 6.47238C0.0761719 10.0326 2.97991 12.9448 6.54855 12.9448ZM6.54856 11.5476C3.76265 11.5476 1.47333 9.24987 1.47333 6.47238C1.47333 3.6949 3.76265 1.39716 6.54856 1.39716C9.32604 1.39716 11.6238 3.6949 11.6238 6.47238C11.6238 9.24987 9.32604 11.5476 6.54856 11.5476Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Search.2ea9a3aee7f5a9c7e1d045a058a8c885.svg";